import Phaser from 'phaser-ce';
import Obstacle from './Obstacle';

const ANIMATION_TIME = 2000;

export default class MovingEnemy extends Obstacle {
  constructor({ game, player, values, road, collideItem, spikes }) {
    super({
      game,
      player,
      values,
      road,
      name: 'movingEnemy',
      collideItem,
      spikes,
    });
    this._chance = 0.008;
    this._deltaSpeed = 1.2;
    this._coordX = 0;
    this._tween = {};
  }
  _moveX(to) {
    if (!this._tween.resume) {
      this._tween = this._game.add.tween(this.item).to({ x: to }, ANIMATION_TIME, Phaser.Easing.Quartic.Out, true);
    }
  }
  _move() {
    super._move();
    this._collidedShield();
    if (this.item.y >= -this.height / 3 && this.item.y <= 0) {
      // если перестраивающийся враг находится на крайних полосах (1 или 3)
      // и статичный враг не на средней полосе (если на средней полосе, то не двигаем перестраивающегося. иначе наслоение будет)
      if ([this.coords.minX, this.coords.maxX].includes(this.item.x) && (this.collideItem.item.x !== this.coords.middleX)) {
        this._moveX(this.coords.middleX); // то двигаем перестраивающегося врага только на среднюю полосу
      } else if (this.item.x === this.coords.middleX && !this._spikes.isActive) { // если перестраивающийся враг на средней полосе
        const items = { ...this.coords };
        delete items.middleX; // то удаляем из его координат среднюю полосу
        // и проверяем координату статичного врага
        if (this.collideItem.item.x === this.coords.minX) { // если статичный враг на 1 полосе
          this._coordX = this.coords.maxX; // то двигаем перестраивающегося врага со средней на 3 полосу
        } else if (this.collideItem.item.x === this.coords.maxX) { // если статичный враг на 3 полосе
          this._coordX = this.coords.minX; // то двигаем перестраивающегося врага со средней на 1 полосу
        } else { // если статичный враг на средней полосе
          this._coordX = MovingEnemy.randomCoord(items); // то двигаем перестраивающегося врага со средней на 1 или 3 полосу
        }
        this._moveX(this._coordX);
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/js/MovingEnemy.js